import type { ReactNode } from 'react'

// Собственный набор тонких outline-иконок (24px, stroke 1.6) — без вендорных
// икон-паков, стиль референса.
const paths = {
  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="m16.6 16.6 4.4 4.4" />
    </>
  ),
  bell: (
    <>
      <path d="M6 8a6 6 0 0 1 12 0c0 7 3 7 3 7H3s3 0 3-7" />
      <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
    </>
  ),
  plus: <path d="M12 5v14M5 12h14" />,
  pen: (
    <>
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
    </>
  ),
  x: <path d="M18 6 6 18M6 6l12 12" />,
  'chevron-down': <path d="m6 9 6 6 6-6" />,
  'chevron-right': <path d="m9 6 6 6-6 6" />,
  server: (
    <>
      <rect x="2" y="3" width="20" height="7" rx="2" />
      <rect x="2" y="14" width="20" height="7" rx="2" />
      <path d="M6.5 6.5h.01M6.5 17.5h.01" />
    </>
  ),
  cpu: (
    <>
      <rect x="6" y="6" width="12" height="12" rx="2" />
      <rect x="9.5" y="9.5" width="5" height="5" rx="1" />
      <path d="M9 4V2M15 4V2M9 22v-2M15 22v-2M4 9H2M4 15H2M22 9h-2M22 15h-2" />
    </>
  ),
  grid: (
    <>
      <rect x="3" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" />
      <rect x="14" y="14" width="7" height="7" rx="1.5" />
    </>
  ),
  phone: (
    <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3A19.5 19.5 0 0 1 5.1 12.8a19.8 19.8 0 0 1-3-8.6A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.13.96.36 1.9.7 2.8a2 2 0 0 1-.45 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.45c.9.34 1.84.57 2.8.7A2 2 0 0 1 22 16.9Z" />
  ),
  'phone-call': (
    <>
      <path d="M19 16.4v2.2a1.6 1.6 0 0 1-1.76 1.6 15.8 15.8 0 0 1-6.88-2.4 15.6 15.6 0 0 1-4.8-4.8 15.8 15.8 0 0 1-2.4-6.9A1.6 1.6 0 0 1 4.76 4.5h2.2a1.6 1.6 0 0 1 1.6 1.36c.1.77.29 1.52.56 2.24a1.6 1.6 0 0 1-.36 1.68l-.94.94a12.8 12.8 0 0 0 4.8 4.8l.94-.94a1.6 1.6 0 0 1 1.68-.36c.72.27 1.47.46 2.24.56A1.6 1.6 0 0 1 19 16.4Z" />
      <path d="M15 3.5a6 6 0 0 1 5.5 5.5M15.5 7a3 3 0 0 1 2.5 2.5" />
    </>
  ),
  layers: (
    <>
      <path d="m12 2 10 5.5L12 13 2 7.5Z" />
      <path d="m2 12.5 10 5.5 10-5.5" />
      <path d="m2 17.5 10 5.5 10-5.5" />
    </>
  ),
  'id-card': (
    <>
      <rect x="2" y="5" width="20" height="14" rx="2.5" />
      <circle cx="8" cy="11" r="2" />
      <path d="M5.5 16c.6-1.6 4.4-1.6 5 0M14 9.5h5M14 13h4" />
    </>
  ),
  link: (
    <>
      <path d="M10 13a5 5 0 0 0 7.5.5l2.5-2.5a5 5 0 0 0-7-7L11.5 5.5" />
      <path d="M14 11a5 5 0 0 0-7.5-.5L4 13a5 5 0 0 0 7 7l1.5-1.5" />
    </>
  ),
  chart: (
    <>
      <path d="M3 3v16a2 2 0 0 0 2 2h16" />
      <path d="M8 17v-5M13 17V7M18 17v-3" />
    </>
  ),
  mic: (
    <>
      <rect x="9" y="2" width="6" height="12" rx="3" />
      <path d="M5 11a7 7 0 0 0 14 0M12 18v4" />
    </>
  ),
  pause: <path d="M9 5v14M15 5v14" />,
  play: <path d="m7 4 13 8-13 8Z" />,
  trash: (
    <>
      <path d="M3 6h18" />
      <path d="M8 6V4a1.5 1.5 0 0 1 1.5-1.5h5A1.5 1.5 0 0 1 16 4v2" />
      <path d="m19 6-.8 13a2 2 0 0 1-2 1.9H7.8a2 2 0 0 1-2-1.9L5 6" />
      <path d="M10 11v5M14 11v5" />
    </>
  ),
  check: <path d="m4.5 12.5 5 5 10-11" />,
  copy: (
    <>
      <rect x="9" y="9" width="12" height="12" rx="2" />
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </>
  ),
  logout: (
    <>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <path d="m16 17 5-5-5-5M21 12H9" />
    </>
  ),
  sun: (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M19.1 4.9l-1.4 1.4M6.3 17.7l-1.4 1.4" />
    </>
  ),
  moon: <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z" />,
  dots: <path d="M5 12h.01M12 12h.01M19 12h.01" strokeWidth="3" />,
  alert: (
    <>
      <path d="M12 3 2.5 20h19Z" />
      <path d="M12 9.5v5M12 17.2h.01" />
    </>
  ),
  shield: <path d="m12 2 8 3.5v5.2c0 5-3.4 8.6-8 11.3-4.6-2.7-8-6.3-8-11.3V5.5Z" />,
  bolt: <path d="M13 2 4 14h6l-1 8 9-12h-6Z" />,
  download: (
    <>
      <path d="M12 3v12" />
      <path d="m7 10 5 5 5-5" />
      <path d="M4 21h16" />
    </>
  ),
  refresh: (
    <>
      <path d="M20 4v5h-5" />
      <path d="M4 20v-5h5" />
      <path d="M20 9a8 8 0 0 0-14.5-3M4 15a8 8 0 0 0 14.5 3" />
    </>
  ),
  'arrow-up-right': <path d="M7 17 17 7M8 7h9v9" />,
  'arrow-down-right': <path d="m7 7 10 10M17 8v9H8" />,
} satisfies Record<string, ReactNode>

export type IconName = keyof typeof paths

interface IconProps {
  name: IconName
  size?: number
  strokeWidth?: number
  className?: string
}

export function Icon({ name, size = 20, strokeWidth = 1.6, className }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {paths[name]}
    </svg>
  )
}
